/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ScopeInputs */

const en__field_scope = /** @type {(inputs: _Field_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

const de__field_scope = /** @type {(inputs: _Field_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereich`)
};

/**
* | output |
* | --- |
* | "Scope" |
*
* @param {_Field_ScopeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_scope = /** @type {((inputs?: _Field_ScopeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ScopeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_scope(inputs)
	return de__field_scope(inputs)
});